export default __webpack_public_path__ + "static/media/logo-positive.fc536e73.svg";